import { createSlice } from "@reduxjs/toolkit";
import { createAsyncActionHandlers } from "../../../helpers/asyncActionHandler";
import {
  credentialList,
  credentialCreate,
  credentialDelete,
  credentialView,
  credentialUpdate,
} from "redux/service/settingsService/credentialService";

const initialState = {
  credentialCreateRes: { data: [], isFetching: false, error: null },
  credentialListRes: { data: [], isFetching: true, error: null },
  credentialDeleteRes: { data: [], isFetching: true, error: null },
  credentialViewRes: { data: [], isFetching: true, error: null },
  credentialUpdateRes: { data: [], isFetching: false, error: null },
};

export const credentialSlice = createSlice({
  name: "credentialSlice",
  initialState,
  extraReducers: (builder) => {
    const asyncActionCases = [
      { api: credentialList, name: "credentialListRes" },
      { api: credentialCreate, name: "credentialCreateRes" },
      { api: credentialDelete, name: "credentialDeleteRes" },
      { api: credentialView, name: "credentialViewRes" },
      { api: credentialUpdate, name: "credentialUpdateRes" },
    ];

    asyncActionCases.map((asyncAction) => {
      createAsyncActionHandlers(builder, asyncAction);
    });
  },
});

export const { credentialDispatch } = credentialSlice.actions;
